{
	"app_sidebar": {
		"menu": {
			"theme": "Theme"
		},
		"theme": {
			"dark": "Dark",
			"light": "Light",
			"system": "System"
		},
		"user_menu": {
			"language": "Language",
			"language_no_results": "No languages found",
			"language_search_placeholder": "Search language..."
		}
	},
	"async_pickers": {
		"empty": "No results found",
		"error": "Failed to load options",
		"selected_count_one": "1 selected",
		"selected_count_other": "{{count}} selected"
	},
	"auth_error_alert": {
		"dismiss": "Dismiss error"
	},
	"color_picker": {
		"alpha": "Alpha",
		"alpha_short": "A",
		"clear": "Clear color",
		"eyedropper": "Pick from screen",
		"format": {
			"hex": "HEX",
			"hsl": "HSL",
			"oklch": "OKLCH",
			"rgb": "RGB"
		},
		"hue": "Hue",
		"hue_short": "H",
		"placeholder": "Pick a color",
		"presets": "Presets",
		"validation": {
			"invalid_color": "Please enter a valid OKLCH color"
		}
	},
	"data_table": {
		"column_settings": {
			"drag_handle": "Reorder column",
			"no_results": "No columns match",
			"pin_column": "Pin {{column}}",
			"pin_left": "Pin left",
			"pin_right": "Pin right",
			"reset": "Reset",
			"search_placeholder": "Search columns...",
			"show_all": "Show all",
			"toggle_visibility": "Toggle {{column}}",
			"trigger": "Columns",
			"unpin": "Unpin"
		},
		"error": "Failed to load data",
		"loading_more": "Loading more...",
		"no_results": "No results",
		"pagination": {
			"go_to_page": "Go to page {{page}}",
			"more_pages": "More pages",
			"next": "Next",
			"previous": "Previous",
			"rows_per_page": "Rows per page"
		},
		"resize_column": "Resize column",
		"select_all": "Select all rows",
		"select_row": "Select row",
		"sort_by": "Sort by {{column}}"
	},
	"date_input": {
		"open_calendar": "Open calendar",
		"validation": {
			"disabled_date": "This date is not available",
			"invalid_date": "Please enter a valid date",
			"max_date": "Date must be on or before {{maxDate}}",
			"min_date": "Date must be on or after {{minDate}}",
			"range": "Date must be between {{minDate}} and {{maxDate}}"
		}
	},
	"date_picker": {
		"cancel": "Cancel",
		"description": "Pick a date from the calendar",
		"presets": {
			"last_7_days": "Last 7 days",
			"last_month": "Last month",
			"last_year": "Last year",
			"this_month": "This month",
			"this_week": "This week",
			"this_year": "This year"
		},
		"submit": "Submit",
		"title": "Select date"
	},
	"drop_zone": {
		"accepted_formats": "Accepted: {{formats}} · up to {{size}}",
		"drag_and_drop_files": "Drag and drop files here",
		"drop_files_here": "Drop files here"
	},
	"file_item": {
		"cancel_upload": "Cancel upload",
		"completed": "Completed",
		"remove": "Remove file",
		"retry_upload": "Retry upload",
		"upload_progress": "Upload progress for {{name}}"
	},
	"filters_sidebar": {
		"applied_filters": "Applied filters",
		"apply_filters": "Apply filters",
		"available_filters": "Available filters",
		"close": "Close",
		"remove_filters_one": "Remove filter",
		"remove_filters_other": "Remove all filters",
		"title": "Filters"
	},
	"http_errors": {
		"admin_already_verified": "This account is already activated. Go to sign in.",
		"admin_email_already_exists": "An admin with this email already exists.",
		"admin_forbidden": "You don't have permission to perform this admin action.",
		"admin_invite_token_invalid": "This invitation link has expired or has already been used. Ask your administrator for a new invitation.",
		"admin_reset_password_session_missing": "The admin password reset session is missing.",
		"admin_reset_password_token_invalid": "The admin password reset token is invalid or expired.",
		"admin_session_not_found": "This admin session could not be found.",
		"admin_target_user_not_found": "The selected admin user could not be found.",
		"admin_user_already_deleted": "This admin user has already been deleted.",
		"admin_user_not_found": "Account not found. Contact an administrator.",
		"anonymous_sign_in_disabled": "Anonymous sign-in is disabled.",
		"anonymous_user_cannot_change_password": "Anonymous users cannot change their password.",
		"anonymous_users_cannot_sign_in_again_anonymously": "Anonymous users can't sign in anonymously again.",
		"api_key_invalid": "The API key is invalid.",
		"apple_android_ott_invalid": "The Apple Android sign-in token is invalid.",
		"apple_android_sign_in_failed": "Apple Android sign-in failed.",
		"apple_mobile_deep_link_not_allowed": "Apple mobile sign-in links are not allowed.",
		"apple_mobile_ott_invalid": "The Apple mobile sign-in token is invalid.",
		"apple_mobile_sign_in_failed": "Apple mobile sign-in failed.",
		"asset_corrupted": "This file could not be processed. Upload it again.",
		"asset_mime_type_not_allowed": "This file type is not allowed.",
		"asset_not_found": "This file could not be found.",
		"asset_ownership_error": "You do not have access to this file.",
		"asset_size_too_large": "This file is too large.",
		"asset_storage_missing": "File storage is not available.",
		"auth_credentials_missing": "Sign in before continuing.",
		"auth_csrf_invalid": "Your session security token is invalid. Refresh and try again.",
		"auth_email_not_found": "No account with this email address could be found.",
		"auth_jwt_invalid": "Your sign-in session is invalid or has expired. Sign in again.",
		"auth_session_issue_failed": "We couldn't complete sign-in. Please try again.",
		"auth_token_invalid": "Your sign-in session is invalid or has expired. Start again.",
		"backoffice_admin_deleted": "This admin account has been deleted.",
		"backoffice_admin_disabled": "This admin account is disabled. Contact an administrator.",
		"backoffice_admin_not_found": "This admin account could not be found.",
		"backoffice_auth_credentials_missing": "Sign in as an admin before continuing.",
		"backoffice_auth_token_invalid": "Your sign-in session is invalid or has expired. Start again.",
		"backoffice_challenge_not_found": "The admin authentication challenge could not be found.",
		"backoffice_change_password_otp_invalid": "The email code is invalid. Please try again.",
		"backoffice_change_password_otp_unavailable": "Email codes are not available for changing this admin password.",
		"backoffice_change_password_totp_invalid": "The authenticator code is invalid. Please try again.",
		"backoffice_csrf_invalid": "Your admin session security token is invalid. Refresh and try again.",
		"backoffice_disable_two_factor_method_not_available": "No available method can disable two-factor authentication for this admin account.",
		"backoffice_disable_two_factor_otp_invalid": "The email code is invalid. Please try again.",
		"backoffice_disable_two_factor_otp_unavailable": "Email codes are not available for disabling two-factor authentication on this admin account.",
		"backoffice_disable_two_factor_passkey_invalid": "Passkey verification failed. Please try again.",
		"backoffice_disable_two_factor_recovery_code_invalid": "The recovery code is invalid. Please try again.",
		"backoffice_disable_two_factor_totp_invalid": "The authenticator code is invalid. Please try again.",
		"backoffice_email_already_in_use": "An admin account with this email already exists.",
		"backoffice_email_change_token_invalid": "The admin email change session is invalid or has expired.",
		"backoffice_email_otp_token_invalid": "Your verification session has expired. Request a new code.",
		"backoffice_failed_to_verify_registration": "The admin passkey registration could not be verified.",
		"backoffice_invalid_code": "The code is invalid.",
		"backoffice_invalid_email_or_password": "The email or password is invalid.",
		"backoffice_invalid_password": "The password is invalid.",
		"backoffice_invite_invalid": "This admin invitation is invalid or has expired.",
		"backoffice_jwt_invalid": "Your admin session is invalid or has expired. Sign in again.",
		"backoffice_mfa_challenge_invalid": "Your verification session has expired. Sign in again.",
		"backoffice_mfa_challenge_required_for_change_password": "Verify your identity before changing this admin password.",
		"backoffice_mfa_device_limit_reached": "This admin account has reached the two-factor device limit.",
		"backoffice_mfa_email_otp_not_available": "Email verification codes aren't available for this account.",
		"backoffice_mfa_enrollment_expired": "Two-factor setup has expired. Start again.",
		"backoffice_mfa_invalid_backup_code": "The backup code is invalid. Please try again.",
		"backoffice_mfa_invalid_email_otp": "The email code is invalid. Please try again.",
		"backoffice_mfa_invalid_passkey": "Passkey verification failed. Please try again.",
		"backoffice_mfa_invalid_totp_code": "The authenticator code is invalid. Please try again.",
		"backoffice_mfa_not_enabled": "Two-factor authentication is not enabled for this admin account.",
		"backoffice_mfa_passkey_not_available": "Passkey verification is not available for this admin account.",
		"backoffice_new_email_same_as_current": "The new admin email matches the current email.",
		"backoffice_no_change_password_method_available": "No available method can change this admin password.",
		"backoffice_passkey_authentication_failed": "Admin passkey authentication failed.",
		"backoffice_passkey_limit_reached": "This admin account has reached the passkey limit.",
		"backoffice_passkey_not_found": "This admin passkey could not be found.",
		"backoffice_reset_password_session_missing": "The admin password reset session is missing.",
		"backoffice_reset_password_token_invalid": "The admin password reset token is invalid or expired.",
		"backoffice_self_edit_forbidden": "You cannot edit your own admin account here.",
		"backoffice_session_expired": "Your admin session has expired. Sign in again.",
		"backoffice_session_invalid": "Your admin session is no longer valid. Sign in again.",
		"backoffice_session_issue_failed": "We couldn't complete sign-in. Please try again.",
		"backoffice_social_not_registered": "No admin account is registered for this social sign-in.",
		"backoffice_totp_authenticator_not_found": "This admin authenticator could not be found.",
		"backoffice_you_are_not_allowed_to_register_this_passkey": "You are not allowed to register this admin passkey.",
		"backup_codes_not_enabled": "Backup codes are not enabled for this account.",
		"blacklisted_email_domain": "This email domain is not allowed.",
		"challenge_not_found": "The authentication challenge could not be found.",
		"change_password_otp_invalid": "The email code is invalid. Please try again.",
		"change_password_otp_unavailable": "Email codes are not available for changing this password.",
		"change_password_totp_invalid": "The authenticator code is invalid. Please try again.",
		"chat_conversation_not_found": "The selected conversation is no longer available.",
		"chat_group_operation_on_direct": "This action is only available for group conversations.",
		"chat_idempotency_key_conflict": "This message was already submitted with different content.",
		"chat_invalid_member_count": "Choose a valid number of conversation members.",
		"chat_message_not_in_conversation": "The selected message does not belong to this conversation.",
		"chat_not_member": "You are not a member of this conversation.",
		"chat_peer_not_found": "The selected user could not be found.",
		"chat_self_membership": "You can't start a conversation with yourself.",
		"chat_target_not_member": "The selected user is not a member of this conversation.",
		"conversation_not_found": "This conversation could not be found.",
		"credential_account_not_found": "The credential account could not be found.",
		"csrf_token_mismatch": "Your session security token is stale. Refresh and try again.",
		"default": "Oops! Something went wrong.",
		"delete_anonymous_user_disabled": "Anonymous user deletion is disabled.",
		"disable_two_factor_method_not_available": "No available method can disable two-factor authentication for this account.",
		"disable_two_factor_otp_invalid": "The email code is invalid. Please try again.",
		"disable_two_factor_otp_unavailable": "Email codes are not available for disabling two-factor authentication on this account.",
		"disable_two_factor_passkey_invalid": "Passkey verification failed. Please try again.",
		"disable_two_factor_recovery_code_invalid": "The recovery code is invalid. Please try again.",
		"disable_two_factor_totp_invalid": "The authenticator code is invalid. Please try again.",
		"email_already_in_use": "An account with this email already exists.",
		"email_already_verified": "This email address is already verified.",
		"email_can_not_be_updated": "This email address can't be updated.",
		"email_change_current_code_invalid": "The code sent to your current address is not valid. Try again.",
		"email_change_new_code_invalid": "The code sent to the new address is not valid. Try again.",
		"email_change_token_invalid": "The email change session is invalid or has expired.",
		"email_domain_not_allowed": "This email domain is not allowed for admin accounts.",
		"email_mismatch": "The email address does not match.",
		"email_not_verified": "This email address is not verified.",
		"email_otp_token_invalid": "Your verification session has expired. Request a new code.",
		"email_password_disabled": "Email and password sign-in is disabled.",
		"email_password_sign_up_disabled": "Email and password sign-up is disabled.",
		"expires_in_is_too_large": "The expiration duration is too long.",
		"expires_in_is_too_small": "The expiration duration is too short.",
		"export_not_found": "This export could not be found.",
		"export_too_large_for_sync": "This export is too large for direct download. Use auto or email when ready.",
		"failed_to_create_session": "The session could not be created.",
		"failed_to_create_user": "The user could not be created.",
		"failed_to_delete_anonymous_user": "The anonymous user could not be deleted.",
		"failed_to_get_user_info": "The user information could not be loaded.",
		"failed_to_update_passkey": "The passkey could not be updated.",
		"failed_to_verify_registration": "The registration could not be verified.",
		"forbidden": "You don't have permission to perform this action.",
		"id_token_not_supported": "This identity token is not supported.",
		"impersonation_token_invalid": "This impersonation link is invalid or has already expired.",
		"invalid_backup_code": "The backup code is invalid.",
		"invalid_code": "The code is invalid.",
		"invalid_delete_account_otp": "The account deletion code is invalid.",
		"invalid_email": "The email address is invalid.",
		"invalid_email_or_password": "The email or password is invalid.",
		"invalid_metadata_type": "The metadata type is invalid.",
		"invalid_name_length": "The name length is invalid.",
		"invalid_otp": "The one-time password is invalid.",
		"invalid_password": "The password is invalid.",
		"invalid_prefix_length": "The prefix length is invalid.",
		"invalid_remaining": "The remaining value is invalid.",
		"invalid_token": "The token is invalid or expired.",
		"invalid_two_factor_cookie": "The two-factor authentication cookie is invalid.",
		"key_not_found": "The API key could not be found.",
		"last_social_account_without_email": "Add an email address before unlinking your last social account.",
		"llm_not_configured": "The AI service is not available right now.",
		"magic_link_session_missing": "The magic link session is missing.",
		"magic_link_token_invalid": "The magic link token is invalid or expired.",
		"maintenance_mode": "The service is temporarily in maintenance mode.",
		"message_not_found": "This message could not be found.",
		"metadata_disabled": "Metadata is disabled for this API key.",
		"mfa_challenge_invalid": "Your verification session has expired. Sign in again.",
		"mfa_challenge_required_for_change_password": "Verify your identity before changing your password.",
		"mfa_device_limit_reached": "This account has reached the two-factor device limit.",
		"mfa_email_otp_not_available": "Email verification codes aren't available for this account.",
		"mfa_enrollment_expired": "Two-factor setup has expired. Start again.",
		"mfa_invalid_backup_code": "The backup code is invalid. Please try again.",
		"mfa_invalid_email_otp": "The email code is invalid. Please try again.",
		"mfa_invalid_passkey": "Passkey verification failed. Please try again.",
		"mfa_invalid_totp_code": "The authenticator code is invalid. Please try again.",
		"mfa_not_enabled": "Two-factor authentication is not enabled for this account.",
		"mfa_passkey_not_available": "Passkey verification is not available for this account.",
		"mfa_requires_identity": "Verify your identity before managing two-factor authentication.",
		"name_required": "A name is required.",
		"new_email_same_as_current": "The new email matches the current email.",
		"no_change_password_method_available": "No available method can change this password.",
		"no_values_to_update": "There are no values to update.",
		"otp_expired": "The one-time password has expired.",
		"otp_has_expired": "The one-time password has expired. Request a new code.",
		"otp_issuance_throttled": "Too many code requests. Please wait before requesting a new one.",
		"otp_not_enabled": "One-time passwords are not enabled.",
		"passkey_authentication_failed": "Passkey authentication failed.",
		"passkey_limit_reached": "This account has reached the passkey limit.",
		"passkey_not_found": "The passkey could not be found.",
		"passkey_session_missing": "The passkey session is missing.",
		"password_too_long": "The password is too long.",
		"password_too_short": "The password is too short.",
		"permission_denied": "Your account is signed in, but it doesn't have the permissions required to view this page.",
		"provider_not_found": "The authentication provider could not be found.",
		"reset_password_disabled": "Password reset is disabled.",
		"reset_password_session_missing": "The password reset session is missing.",
		"reset_password_token_invalid": "The password reset token is invalid or expired.",
		"resolve_user_required": "A user must be resolved before continuing.",
		"resolved_user_invalid": "The resolved user is invalid.",
		"server_only_property": "This property can only be changed by the server.",
		"session_expired": "Your session has expired. Sign in again.",
		"session_invalid": "Your session is no longer valid. Sign in again.",
		"session_not_found": "This session could not be found.",
		"session_not_fresh": "Please reauthenticate before continuing.",
		"session_required": "A valid session is required.",
		"sign_up_session_missing": "The sign-up session is missing.",
		"social_account_already_linked": "This social account is already linked.",
		"social_code_exchange_failed": "Social sign-in could not be completed. Please try again.",
		"social_email_not_verified": "The social account email address is not verified.",
		"social_provider_not_configured": "This social sign-in provider is not configured.",
		"social_redirect_uri_not_allowed": "This social sign-in redirect is not allowed.",
		"social_token_invalid": "The social sign-in token is invalid or expired.",
		"too_many_attempts": "Too many attempts. Please try again later.",
		"too_many_attempts_request_new_code": "Too many attempts. Request a new code.",
		"totp_authenticator_not_found": "This authenticator could not be found.",
		"totp_not_enabled": "Authenticator app codes are not enabled.",
		"two_factor_not_enabled": "Two-factor authentication is not enabled.",
		"unable_to_create_session": "A new session could not be created.",
		"unauthorized": "You're not signed in. Please log in to continue.",
		"unauthorized_session": "This session is not authorized.",
		"user_already_exists_use_another_email": "A user with this email already exists. Use another email address.",
		"user_already_has_provider_linked": "This user already has that provider linked.",
		"user_banned": "This user account has been banned.",
		"user_deleted": "This user account has been deleted.",
		"user_email_not_found": "No user with this email address could be found.",
		"user_is_not_anonymous": "This user is not anonymous.",
		"user_not_found": "This user could not be found.",
		"validation_error": "Some of the information you entered is invalid.",
		"verification_email_not_enabled": "Verification emails are not enabled.",
		"verify_email_session_missing": "The email verification session is missing.",
		"verify_email_token_invalid": "The email verification token is invalid or expired.",
		"web_push_not_configured": "Web push notifications are not configured.",
		"you_are_not_allowed_to_register_this_passkey": "You're not allowed to register this passkey."
	},
	"infinite_virtual_list": {
		"empty": "No results",
		"error": "Failed to load data"
	},
	"inline_filter_date": {
		"from": "From {{date}}",
		"to": "Until {{date}}"
	},
	"inline_filters": {
		"clear": "Clear filter",
		"clear_all": "Clear all"
	},
	"input_currency": {
		"empty": "No currency found",
		"search": "Search currency...",
		"select_currency": "Select currency",
		"validation": {
			"invalid_amount": "Please enter a valid amount"
		}
	},
	"input_password": {
		"hide": "Hide password",
		"show": "Show password"
	},
	"input_phone": {
		"empty": "No country found",
		"search": "Search country...",
		"select_country": "Select country",
		"validation": {
			"invalid_phone_number": "Please enter a valid phone number"
		}
	},
	"list_input_search": {
		"clear": "Clear search"
	},
	"query_breadcrumbs": {
		"error": "Error",
		"no_data": "Detail"
	},
	"rich_text_editor": {
		"blocks": {
			"blockquote": "Blockquote",
			"bulleted_list": "Bulleted list",
			"code_block": "Code block",
			"h1": "Heading 1",
			"h2": "Heading 2",
			"h3": "Heading 3",
			"numbered_list": "Numbered list"
		},
		"code_block_languages": {
			"bash": "Bash",
			"css": "CSS",
			"html": "HTML",
			"js": "JavaScript",
			"json": "JSON",
			"md": "Markdown",
			"plain": "Plain text",
			"python": "Python",
			"ts": "TypeScript"
		},
		"editor_label": "Rich text editor",
		"mention": {
			"empty": "No matches"
		},
		"slash": {
			"empty": "No commands match"
		},
		"toolbar": {
			"bold": "Bold",
			"italic": "Italic",
			"underline": "Underline"
		}
	},
	"two_factor": {
		"backup_description": "Enter one of your single-use backup codes.",
		"backup_label": "Backup code",
		"verify": "Verify"
	},
	"two_factor_device_picker": {
		"device_label": "Authenticator device",
		"device_unnamed": "Unnamed device"
	},
	"validation": {
		"otp_length": "Code must be 6 digits."
	}
}
